import { render, staticRenderFns } from "./SendTestMessage.vue?vue&type=template&id=30980a14&"
import script from "./SendTestMessage.vue?vue&type=script&lang=js&"
export * from "./SendTestMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports